'use strict';

function emptyFunction() {}

module.exports = emptyFunction;




// WEBPACK FOOTER //
// ./src/utils/empty-function.js